<div class="filters" [style.heigth.px]="containerTopValue">
  <div class="chips-container" [@chips]="collapsed" (click)="toggle()">
    <div class="chips-actions start" *ngIf="(availableShops > 1 || availablePrinters > 1) && !collapsed">
      <button mat-mini-fab (click)="toggleSelect($event)" color="primary">
        <fa-icon [icon]="faMenu"></fa-icon>
      </button>
    </div>
    <div class="chips" (resized)="onResizeChipsHeight($event)">
      <mat-chip-list>
        <mat-chip [disableRipple]="true" *ngFor="let chip of filtersChips" matTooltip="{{getChipTooltip(chip)}}"
          matTooltipClass="advanced-filters-tooltip" (click)="$event.stopPropagation()">
          <div class="mat-chip-text">
            <span class="chip-name">{{getChipName(chip)}}</span>{{getChipValue(chip)}}
          </div>
          <button matChipRemove (click)="onRemoveChip(chip.name, $event)"
            *ngIf="chip.name != 'shops' && chip.name != 'printers'">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
      </mat-chip-list>
    </div>
    <span class="chips-gap"></span>
    <div class="chips-actions end">
      <button mat-mini-fab type="submit" (click)="onApply($event)" color="accent" class="extended" *ngIf="!collapsed"
        [disabled]="!isFiltersFormValid()">
        {{'common.advanced-filters.apply' | translate}}
        <fa-icon [icon]="faApply"></fa-icon>
      </button>
      <button mat-icon-button color="primary" aria-label="Expand-collapse filters" [@rotateIcon]="collapsed">
        <fa-icon [icon]="faFilter" size="2x"></fa-icon>
      </button>
    </div>
  </div>

  <div class="filters-content-container" [@filters]="collapsed" [style.height.px]="containerHeight">

    <div class="select-container" [@collapseSelect]="collapsedSelect"
      *ngIf="availableBrands > 1 || availableShops > 1 || availablePrinters > 1">
      <app-brand *ngIf="availableBrands > 1" [brands]="brands"
        (selectedChange)="onBrandSelectedChange($event)"></app-brand>
      <div class="select-column" [ngClass]="{'select-column-border': availableBrands > 0}"
        *ngIf="!isInitialLoad || availableShops > 1">
        <ng-container *ngTemplateOutlet="shopsTemplate; context: { shopsData: shops }"></ng-container>
      </div>
      <div class="select-column" [ngClass]="{'select-column-border': availableShops > 1}"
        *ngIf="!isInitialLoad || availablePrinters >= 1">
        <ng-container *ngTemplateOutlet="printersTemplate; context: { printersData: printers }"></ng-container>
      </div>
    </div>

    <div class="filters-content"
      [@expandContent]="{value:collapsedSelect, params:{marginLeft:getFiltersContentMargin()}}"
      [style.margin-left.px]="getFiltersContentMargin()">
      <form [formGroup]="filtersForm" (keydown.enter)="$event.preventDefault()">
        <ng-container [ngSwitch]="currentNavigation()">

          <ng-container *ngSwitchCase="'sales-statement'">
            <div class="filters-row">
              <div class="filters-column">
                <ng-container *ngTemplateOutlet="dateRangeTemplate"></ng-container>
                <ng-container *ngTemplateOutlet="salesStatementParametersTemplate"></ng-container>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'receipts'">
            <div class="filters-row">
              <ng-container *ngTemplateOutlet="dateRangeTemplate"></ng-container>

              <ng-container *ngTemplateOutlet="timeRangeTemplate; 
                  context { control: timeRangeFormControl, name: 'time', type: 'time-range'}">
              </ng-container>

              <ng-container *ngTemplateOutlet="numberRangeTemplate; 
                  context { control: documentNumberRangeFormControl, name: 'document-number', type: 'number-range'}">
              </ng-container>

              <ng-container *ngTemplateOutlet="numberRangeTemplate; 
                  context { control: fiscalNumberRangeFormControl, name: 'fiscal-number', type: 'number-range'}">
              </ng-container>

              <ng-container *ngTemplateOutlet="numberRangeTemplate; 
                  context { control: grossAmountRangeFormControl, name: 'gross-amount', type: 'amount-range'}">
              </ng-container>

              <ng-container *ngTemplateOutlet="optionTemplate; 
                  context: { control: tinNumberFormControl, model: isCancelled, name: 'is-cancelled' }">
              </ng-container>

              <ng-container *ngTemplateOutlet="numberWithOptionsTemplate; 
                  context: { control: tinNumberFormControl, model: hasTinNumber, name: 'tin' }">
              </ng-container>

              <ng-container
                *ngTemplateOutlet="numberWithOptionsTemplate;
                  context: { control: transactionNumberFormControl, model: hasTransactionNumber, name: 'transaction-number' }">
              </ng-container>

              <ng-container *ngTemplateOutlet="numberWithOptionsTemplate; 
                  context: { control: systemNumberFormControl, model: hasSystemNumber, name: 'system-number' }">
              </ng-container>

              <ng-container *ngTemplateOutlet="productsTemplate; 
                context: { productsData: products }">
              </ng-container>

              <ng-container *ngTemplateOutlet="selectTemplate;
                context: { control: paymentsFormControl, model: payments, name: 'payments' }">
              </ng-container>

            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'daily-reports'">
            <div class="filters-row">
              <ng-container *ngTemplateOutlet="dateRangeTemplate"></ng-container>

              <ng-container *ngTemplateOutlet="numberRangeTemplate; 
                context { control: documentNumberRangeFormControl, name: 'document-number', type: 'number-range'}">
              </ng-container>

              <ng-container *ngTemplateOutlet="numberRangeTemplate; 
                context { control: fiscalNumberRangeFormControl, name: 'fiscal-number', type: 'number-range'}">
              </ng-container>

              <ng-container *ngTemplateOutlet="numberRangeTemplate; 
                context { control: grossAmountRangeFormControl, name: 'gross-amount', type: 'amount-range'}">
              </ng-container>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'non-fiscals'">
            <div class="filters-row">
              <ng-container *ngTemplateOutlet="dateRangeTemplate"></ng-container>

              <ng-container *ngTemplateOutlet="timeRangeTemplate; 
                context { control: timeRangeFormControl, name: 'time', type: 'time-range'}">
              </ng-container>

              <ng-container *ngTemplateOutlet="numberRangeTemplate; 
                context { control: documentNumberRangeFormControl, name: 'document-number', type: 'number-range'}">
              </ng-container>

              <ng-container *ngTemplateOutlet="optionTemplate; 
                context: { control: tinNumberFormControl, model: isCancelled, name: 'is-cancelled' }">
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </form>
    </div>
  </div>
</div>

<!-- TEMPLATES -->
<ng-template #shopsTemplate let-shops="shopsData">
  <div class="select-list-header" [ngClass]="{'list-header-disabled': shops.array.length == 0}">
    <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="onSelectAll(shopsList, shops)"
      matTooltip="{{(isChecked(shopsList, shops) ? 'common.deselect-all' : 'common.select-all') | translate}}"
      matTooltipPosition="right" [checked]="isChecked(shopsList, shops)"
      [indeterminate]="isIndeterminate(shopsList, shops)" [disabled]="shops.array.length == 0">
    </mat-checkbox>

    <div class="search-container">
      <mat-form-field class="shop-search-field" appearance="outline">
        <input matInput type="text" [placeholder]="'common.advanced-filters.shops' | translate" autocomplete="off"
          #shopInput (input)="onShopInput(shopInput.value)">
      </mat-form-field>
    </div>
  </div>

  <div class="select-list">
    <mat-selection-list #shopsList (selectionChange)="onSelectionChange(shopsList, shops)">
      <div *ngFor="let brand of selectedBrands">
        <div class="select-list-group" *ngIf="brands.length > 1 && brand.shops.length > 0">
          {{brand.name}}
        </div>
        <mat-list-option color="primary" checkboxPosition="before" [value]="{id: shop.id, name: shop.number}"
          *ngFor="let shop of brand.shops">
          {{shop.number}}
          <span class="select-list-name">{{shop.name}}</span>
        </mat-list-option>
      </div>
    </mat-selection-list>
  </div>
</ng-template>

<ng-template #printersTemplate let-printers="printersData">
  <div class="select-list-header" [ngClass]="{'list-header-disabled': printers.array.length == 0}">
    <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="onSelectAll(printersList, printers)"
      matTooltip="{{(isChecked(printersList, printers) ? 'common.deselect-all' : 'common.select-all') | translate}}"
      matTooltipPosition="right" [checked]="isChecked(printersList, printers)"
      [indeterminate]="isIndeterminate(printersList, printers)" [disabled]="printers.array.length == 0">
    </mat-checkbox>

    <div class="search-container">
      <mat-form-field class="printer-search-field" appearance="outline">
        <input matInput type="text" [placeholder]="'common.advanced-filters.printers' | translate" autocomplete="off"
          #printerInput (input)="onPrinterInput(printerInput.value)">
      </mat-form-field>
    </div>
  </div>
  <div class="select-list" [hidden]="printers.array.length == 0">
    <mat-selection-list #printersList (selectionChange)="onSelectionChange(printersList, printers)">
      <div *ngFor="let shop of shops.array">
        <div *ngIf="isSelectedInShopList(shop.id) || shops.array.length == 1">
          <div class="select-list-group" *ngIf="shops.array.length > 1 && shop.printers.length > 0">
            {{shop.number}}
          </div>
          <mat-list-option color="primary" checkboxPosition="before" *ngFor="let printer of shop.printers"
            [value]="{id: printer.id, name: printer.uniqueNumber}">
            {{printer.uniqueNumber}}
            <span class="select-list-name">{{printer.name}}</span>
          </mat-list-option>
        </div>
      </div>
    </mat-selection-list>
  </div>
</ng-template>

<ng-template #productsTemplate let-products="productsData">
  <div class="list">
    <div class="list-header" [ngClass]="{'list-header-disabled': !isProductsFilterEnabled}">
      <mat-checkbox color="primary" (click)="$event.stopPropagation()"
        *ngIf="products && products.array && products.array.length > 0" (change)="onSelectAll(productsList, products)"
        [disabled]="!isProductsFilterEnabled"
        matTooltip="{{(isChecked(productsList, products) ? 'common.deselect-all' : 'common.select-all') | translate}}"
        matTooltipPosition="above" [checked]="isChecked(productsList, products)"
        [matTooltipDisabled]="!isProductsFilterEnabled" [indeterminate]="isIndeterminate(productsList, products)">
      </mat-checkbox>

      <mat-form-field appearance="outline" color="primary" *ngIf="products">
        <input matInput #productSearch type="text" [formControl]="filterProductNameFormControl" autocomplete="off"
          (keyup)="filterProducts()" placeholder="{{'common.advanced-filters.search-product' | translate}}">
      </mat-form-field>

      <mat-slide-toggle [formControl]="showProductsFormControl" color="primary"
        (change)="productsFilterEnabled($event)"></mat-slide-toggle>
    </div>
    <div class="list-content" *ngIf="products && products.array && products.array.length > 0" #productsListContent
      infinite-scroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="500" [scrollWindow]="false"
      (scrolled)="onScrollProducts()" [style.maxHeight]="calcListMaxHeight()">
      <mat-selection-list #productsList (selectionChange)="onSelectionChange(productsList, products)">
        <mat-list-option color="primary" checkboxPosition="before" *ngFor="let item of products.array" [value]="item">
          {{item.name}}
        </mat-list-option>
      </mat-selection-list>
    </div>
    <div class="list-content empty-results"
      *ngIf="isProductsFilterEnabled && products && (!products.array || products.array.length === 0)">
      {{'common.empty-results' | translate}}
    </div>
  </div>
</ng-template>

<ng-template #dateRangeTemplate>
  <mat-form-field class="date-range" appearance="outline" color="primary">
    <mat-label>{{'common.date' | translate}}</mat-label>
    <mat-date-range-input [formGroup]="dateRange" [rangePicker]="picker" [max]="today">
      <input matStartDate formControlName="dateFrom" placeholder="{{'common.from' | translate}}" autocomplete="off"
        (dateChange)="addDateRange(dateRange, 'date', 3)" (focus)="focusDateRange = true"
        (focusout)="focusDateRange = false">
      <input matEndDate formControlName="dateTo" placeholder="{{'common.to' | translate}}" autocomplete="off"
        (dateChange)="addDateRange(dateRange, 'date', 3)" (focus)="focusDateRange = true"
        (focusout)="focusDateRange = false">
    </mat-date-range-input>
    <mat-hint *ngIf="focusDateRange">{{'common.date-format' | translate}} - {{'common.date-format' |
      translate}}</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker>
      <mat-date-range-picker-actions>
        <button mat-button matDateRangePickerCancel>{{'common.cancel' | translate}}</button>
        <button mat-raised-button color="primary" matDateRangePickerApply>{{'common.apply' |
          translate}}</button>
      </mat-date-range-picker-actions>
    </mat-date-range-picker>
    <mat-error *ngIf="dateRange.controls.dateFrom.hasError('matStartDateInvalid')">{{'common.error.date-from-invalid' |
      translate}}</mat-error>
    <mat-error *ngIf="dateRange.controls.dateTo.hasError('matEndDateInvalid')">{{'common.error.date-to-invalid' |
      translate}}</mat-error>
  </mat-form-field>
</ng-template>

<ng-template #timeRangeTemplate let-control="control" let-name="name" let-type="type">
  <mat-form-field appearance="outline" color="primary" class="time-range-input">
    <mat-label>{{'common.advanced-filters.' + name | translate}}</mat-label>
    <time-range-input [formControl]="control"
      (timeRangeChange)="addNumberRange(control, type, name, 6)"></time-range-input>
    <mat-error *ngIf="control.hasError('valueFromGraterThenTo')">{{'common.error.time-from-greater-then-to' |
      translate}}</mat-error>
  </mat-form-field>
</ng-template>

<ng-template #numberRangeTemplate let-control="control" let-name="name" let-type="type">
  <mat-form-field appearance="outline" color="primary">
    <mat-label>{{'common.advanced-filters.' + name | translate}}</mat-label>
    <number-range-input [formControl]="control" [rangeType]="type === 'amount-range' ? 'amount' : 'number'" [name]="name"
      (input)="addNumberRange(control, type, name, 6)"></number-range-input>
    <mat-error *ngIf="control.hasError('valueFromGraterThenTo')">{{'common.error.number-from-greater-then-to' |
      translate}}</mat-error>    
  </mat-form-field>
</ng-template>

<ng-template #optionTemplate let-control="control" let-model="model" let-name="name">
  <div class="input-with-options">
    <mat-button-toggle-group [ngModel]="model" aria-label="option">
      <mat-button-toggle [value]="true"
        (click)="onOptionClick($event, name, control, true)">{{'common.advanced-filters.' + name + '.option-true' |
        translate}}</mat-button-toggle>
      <mat-button-toggle [value]="false"
        (click)="onOptionClick($event, name, control, false)">{{'common.advanced-filters.' + name + '.option-false' |
        translate}} </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</ng-template>

<ng-template #numberWithOptionsTemplate let-control="control" let-model="model" let-name="name">
  <div class="input-with-options" [@resize]="model">
    <mat-button-toggle-group [ngClass]="{'input-with-options-input-visible': model}" [ngModel]="model"
      aria-label="option">
      <mat-button-toggle [value]="true"
        (click)="onOptionClick($event, name, control, true)">{{'common.advanced-filters.' + name + '.option-true' |
        translate}}</mat-button-toggle>
      <mat-button-toggle [value]="false"
        (click)="onOptionClick($event, name, control, false)">{{'common.advanced-filters.' + name + '.option-false' |
        translate}} </mat-button-toggle>
    </mat-button-toggle-group>
    <div class="input-with-options-input" [@showInput]="model">
      <input matInput name="{{name}}" [formControl]="control" numberAndLetterMask
        placeholder="{{'common.advanced-filters.' + name | translate}}"
        (numberChange)="addNumberWithOption(model, control, name, 8)" autocomplete="off" />
    </div>
  </div>
</ng-template>

<ng-template #salesStatementParametersTemplate>
  <div class="filters-group-column" [formGroup]="salesStatementParametersFromGroup">
    <ng-container *ngFor="let parameter of salesStatementParameters">
      <mat-slide-toggle color="primary" [formControlName]="parameter[0]" [labelPosition]="'before'"
        (change)="addParameter(parameter[0])">
        {{('common.advanced-filters.' + (parameter[0] | dashcase)) | translate}}
      </mat-slide-toggle>
    </ng-container>
  </div>
</ng-template>

<ng-template #selectTemplate let-control="control" let-model="model" let-name="name">
  <mat-form-field appearance="outline" color="primary" class="select">
    <mat-label>{{'common.advanced-filters.' + name | translate}}</mat-label>
    <mat-select [formControl]="control" [disableOptionCentering]="true" multiple
      (selectionChange)="addSelectValue(model, control, name, 10)">
      <mat-select-trigger>
        {{getSelectedDescription(control.value?.[0], model) || ''}}
        <span *ngIf="(control.value?.length || 0) > 1" class="select-additional-selection">
          (+{{(control.value?.length || 0) - 1}} {{(control.value?.length === 2 ? 'common.other' : 'common.others') |
          translate | lowercase}})
        </span>
      </mat-select-trigger>
      <mat-option *ngFor="let item of model" [value]="item.id">{{item.description}}</mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>